import { Modal } from 'antd';
import React from 'react';

import {
  AddAssetOptionsForm,
  type AddAssetOptionsFormProps,
} from '@/components/layout/AddAssetOptionsForm';

/** Props for the `AddAssetModal` wrapper — extends `AddAssetOptionsFormProps` with open/close control. */
export interface AddAssetModalProps extends Omit<
  AddAssetOptionsFormProps,
  'active' | 'intro' | 'onCancel' | 'onActionComplete'
> {
  open: boolean;
  onClose: () => void;
}

/** Modal wrapper around `AddAssetOptionsForm` for adding a new knowledge card asset. */
export const AddAssetModal: React.FC<AddAssetModalProps> = ({ open, onClose, ...rest }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Add Asset"
      destroyOnHidden
      getContainer={false}
      footer={null}
    >
      <AddAssetOptionsForm active={open} onCancel={onClose} onActionComplete={onClose} {...rest} />
    </Modal>
  );
};

export default AddAssetModal;
